import { addLiveEventListener } from "./live";

enum ScrollTo {
  TOGGLE = "data-scroll-toggle",
  TARGET = "data-scroll-target",
}

interface ScrollToOptions {
  /**
   * Forces scroll also if element edge is visible
   * @default true
   */
  force?: boolean;
}

export const scrollToTarget = (target: Element, options?: ScrollToOptions) => {
  const force = options?.force ?? true;

  if (force === true) {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  } else {
    const rect = target.getBoundingClientRect();

    if (rect.top < 0) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
};

export const scrollToTargetByName = (
  name: string,
  options?: ScrollToOptions,
) => {
  const scrollTarget = getScrollTargetFromName(name);

  if (scrollTarget !== undefined) {
    scrollToTarget(scrollTarget, options);
  }
};

export const scrollToTargetByHash = (options?: ScrollToOptions) => {
  const name = getNameFromHash();

  if (name !== undefined) {
    scrollToTargetByName(name, options);
  }
};

export const scrollToTargetBySelector = (
  selector: string,
  options?: ScrollToOptions,
) => {
  const target = document.querySelector(selector) ?? undefined;

  if (target !== undefined) {
    scrollToTarget(target, options);
  }
};

export const createScrollToTarget = (options?: ScrollToOptions) => {
  addLiveEventListener(
    "click",
    `[${ScrollTo.TOGGLE}]`,
    (event, currentTarget) => {
      const name = getTargetName(currentTarget);

      if (name !== undefined) {
        const scrollTarget = getScrollTargetFromName(name);

        if (scrollTarget !== undefined) {
          event.preventDefault();
          scrollToTarget(scrollTarget, options);
        }
      }
    },
  );

  window.addEventListener("popstate", () => {
    scrollToTargetByHash();
  });

  window.addEventListener("load", () => {
    scrollToTargetByHash();
  });
};

const getTargetName = (target: Element) => {
  return target.getAttribute(ScrollTo.TOGGLE) ?? undefined;
};

const getScrollTargetFromName = (name: string) => {
  return document.querySelector(`[${ScrollTo.TARGET}="${name}"]`) ?? undefined;
};

const getNameFromHash = () => {
  const name = location.hash.substring(1).trim();

  if (name.length > 0) {
    return name;
  }

  return undefined;
};
